import React from 'react';
import { trustedLogos } from '../mock';

// A logo marquee, placed contextually across pages.
// `category="all"` shows every logo; `pop` renders logos on white chips so they stand out.
const LogoTicker = ({ category, names, heading, gold = false, pop = false, className = '' }) => {
  const logos = names
    ? names.map((n) => trustedLogos.find((l) => l.name === n)).filter(Boolean)
    : category === 'all'
    ? trustedLogos
    : trustedLogos.filter((l) => l.category === category);
  if (!logos.length) return null;

  // Repeat so the -50% marquee loop stays seamless even with few logos.
  const base = logos.length < 6 ? [...logos, ...logos, ...logos, ...logos] : [...logos];
  const loop = [...base, ...base];

  return (
    <section
      className={`py-14 border-y border-white/10 bg-[#0c0c0c] ${className}`}
      data-testid={`logo-ticker-${category.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {heading && (
        <p className={`text-center font-display tracking-[0.35em] uppercase mb-9 ${gold ? 'text-[#c9a85f] text-sm font-semibold' : 'text-white/40 text-xs'}`}>
          {heading}
        </p>
      )}
      <div className="relative overflow-hidden marquee-pause">
        <div className="absolute left-0 top-0 h-full w-24 z-10 bg-gradient-to-r from-[#0c0c0c] to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 h-full w-24 z-10 bg-gradient-to-l from-[#0c0c0c] to-transparent pointer-events-none" />
        <div className={`flex items-center w-max animate-marquee ${pop ? 'gap-6 md:gap-8' : 'gap-16 md:gap-20'}`}>
          {loop.map((logo, i) =>
            pop ? (
              <div
                key={i}
                title={logo.name}
                className="flex items-center justify-center shrink-0 h-24 w-44 px-6 rounded-2xl bg-white shadow-[0_10px_30px_rgba(0,0,0,0.35)] ring-1 ring-black/5 hover:-translate-y-1 transition-transform duration-300"
              >
                <img
                  src={logo.src}
                  alt={logo.name}
                  className="max-h-14 max-w-[130px] w-auto object-contain"
                  loading="lazy"
                />
              </div>
            ) : (
              <img
                key={i}
                src={logo.src}
                alt={logo.name}
                title={logo.name}
                className="h-14 md:h-16 w-auto max-w-[200px] object-contain shrink-0 opacity-75 hover:opacity-100 transition-opacity duration-300"
                loading="lazy"
              />
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default LogoTicker;
